import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Copyright } from '@mui/icons-material';
import './Footer.css';

const Footer = () => {


  return (
    <Box className="footer-container">
      <Box className="footer-content">
        <Box className="footer-left">
          <Copyright className="copyright-icon" />
          <Typography 
            variant="body2" 
            className="copyright-text"
            sx={{ cursor: 'pointer' }}
          >
             © 2026 Agricuture. All rights reserved | Design by IT-Team Department of Agriculture
          </Typography>
        </Box>
        
        
      </Box>
    </Box>
  );
};

export default Footer;
